<template>
    <div>
        <nav class="navbar is-warning is-fixed-top" role="navigation">
            <div class="container ">
                <div class="navbar-brand">
                    <router-link class="navbar-item" to="/">
                        <img src="../../../assets/images/logo.png" alt="UltraShop.uz - Каждому по ноутбуку!" width="256"
                             height="48">
                    </router-link>
                    <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div id="navbarExampleTransparentExample" class="navbar-menu">
                    <div class="navbar-end">
                        <div class="navbar-item">
                            <a href="https://ultrashop.uz:8000/media/pricelist/ultrashop_pricelist_KpWEAiF.xlsx">
                                <button class="button is-danger">
                                    Прайслист
                                </button>
                            </a>
                        </div>
                        <div class="navbar-item">
                            <router-link to="/awaiting">
                                <button class="button is-danger">
                                    Под Заказ
                                </button>
                            </router-link>
                        </div>
                        <div class="navbar-item">
                            <router-link to="/sale">
                                <button class="button is-danger">
                                    Распродажа
                                </button>
                            </router-link>
                        </div>
                        <a class="navbar-item" href="tel: +998 98 128 58 72">
                            <img src="../../../assets/images/social/phone.png" width="16">
                            <span class=" has-text-weight-bold"> +998 98 128 58 72</span>
                        </a>
                        <a class="navbar-item" href="https://telegram.me/ultrashopuz" target="_blank">
                            <img src="../../../assets/images/social/telegram.png" width="16">
                            <span class=" has-text-weight-bold"> @ultrashopuz</span>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
        <section class="section">
            <div class="container">
                <Search />
                <b-taglist v-if="perks.length">
                    <p>Часто ищут:
                        <b-tag type="is-small is-warning">
                            <router-link :to="'/noutbuki'">
                                Ноутбуки
                            </router-link>
                        </b-tag>
                        <b-tag type="is-small is-warning">
                            <router-link :to="'/monobloki'">
                                Моноблоки
                            </router-link>
                        </b-tag>
                        <b-tag type="is-small is-warning">
                            <router-link :to="'/categories/printery-1'">
                                Принтеры
                            </router-link>
                        </b-tag>
                        <b-tag type="is-small is-warning" v-for="perk in perks" :key="perk.id">
                            <router-link :to="'/tags/' + perk.slug">
                                {{perk.name}}
                            </router-link>
                        </b-tag>
                    </p>
                </b-taglist>
            </div>
        </section>
        <div id="fb-root"></div>
    </div>
</template>
<script>
    import Search from "../Search2";

    export default {
        name: "Header2",
        components: {Search},
        props: {
          perks: []
        },
        data() {
            return {
                brands: [],
                laptopTypes: [],
                API_URL: process.env.VUE_APP_API_URL,
            }
        },
        created() {
            document.addEventListener('DOMContentLoaded', () => {

                // Get all "navbar-burger" elements
                const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

                // Check if there are any navbar burgers
                if ($navbarBurgers.length > 0) {

                    // Add a click event on each of them
                    $navbarBurgers.forEach(el => {
                        el.addEventListener('click', () => {

                            // Get the target from the "data-target" attribute
                            const target = el.dataset.target;
                            const $target = document.getElementById(target);

                            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                            el.classList.toggle('is-active');
                            $target.classList.toggle('is-active');

                        });
                    });
                }

            })
        }
    }
</script>
<style scoped>
    .navbar-item img {
        max-height: 256px;
    }
</style>
